import { render, staticRenderFns } from "./zulin-project-audit.vue?vue&type=template&id=5f05057c"
import script from "./zulin-project-audit.vue?vue&type=script&lang=js"
export * from "./zulin-project-audit.vue?vue&type=script&lang=js"
import style0 from "./zulin-project-audit.vue?vue&type=style&index=0&id=5f05057c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports